import { updateModeCell } from '../blocks/equipment.js';

document.querySelectorAll('.js-adaptive-row').forEach(row => {
    row.addEventListener('click', e => {
        if (e.target.dataset.label !== undefined || e.target.nodeName !== 'TD') return;

        // Закрыть остальные строки
        document.querySelectorAll('.js-adaptive-row.expanded').forEach(openRow => {
            if (openRow !== row) {
                openRow.classList.remove('expanded');
                // Обновить ячейки в закрытых строках
                openRow.querySelectorAll('.js-equip-fact-input').forEach(el => {
                    updateModeCell(el);
                });
            }
        });

        // Переключить текущую строку
        row.classList.toggle('expanded');
        // Обновить ячейки в текущей строке
        row.querySelectorAll('.js-equip-fact-input').forEach(el => {
            updateModeCell(el);
        });
    });
});
